import { Box, Divider, Typography } from "@mui/material";
import React, { FC } from "react";

import "../ots.css";
import MyGateLogo from "../../../assets/logos/mygate-logo.jpg";
import { ReactComponent as GateGuardConnectLogo } from "../../../assets/logos/gg-connect-logo.svg";
import { ReactComponent as GateGuardOnPremiseLogo } from "../../../assets/logos/gg-onprem.svg";
import { ReactComponent as GateGuardOfflineLogo } from "../../../assets/logos/gg-offline.svg";
import { useNavigate } from "react-router-dom";
import { CONFIG_MODE_E } from "../../../utils/constants";

const IntegrationSelection: FC = () => {
	const navigate = useNavigate();

	function handleSelectMyGateIntegration() {
		navigate("/ots/mygate-device-setup", { state: { mode: CONFIG_MODE_E.MY_GATE } });
	}

	function handleSelectGateGuardIntegration() {
		navigate("/ots/device-registration", { state: { mode: CONFIG_MODE_E.GATE_GUARD } });
	}

	function handleSelectGateGuardOnPremiseIntegration() {
		navigate("/ots/device-registration", { state: { mode: CONFIG_MODE_E.GATE_GUARD_ON_PREMISE } });
	}

	function handleSelectGateGuardOfflineIntegration() {
		navigate("/ots/device-registration", { state: { mode: CONFIG_MODE_E.GATE_GUARD_OFFLINE } });
	}

	return (
		<Box className="integration-selection-cards-wrapper" sx={{ flexWrap: "wrap", gap: "1.5rem" }}>
			{/* MyGate Card */}
			<Box className="integration-card-wrapper" sx={{ minWidth: "300px", flex: "1 1 45%" }}>
				<Box className="integration-card" onClick={handleSelectMyGateIntegration}>
					<Box className="integration-card-image-wrapper">
						<img src={MyGateLogo} alt="MyGate" />
					</Box>

					<Box className="integration-card-content-wrapper">
						<Typography variant="h6">MyGate</Typography>

						<Divider
							sx={{
								borderWidth: "2px",
								borderColor: "var(--color-primary-main)",
								marginTop: "0.25rem",
								marginBottom: "0.5rem"
							}}
						/>

						<Typography variant="body2" sx={{ color: "text.secondary" }}>
							Integrate with MyGate for seamless residential access management
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* GateGuard Connect Card */}
			<Box className="integration-card-wrapper" sx={{ minWidth: "300px", flex: "1 1 45%" }}>
				<Box className="integration-card" onClick={handleSelectGateGuardIntegration}>
					<Box className="integration-card-image-wrapper">
						<GateGuardConnectLogo className="connect" />
					</Box>

					<Box className="integration-card-content-wrapper">
						<Typography variant="h6">GateGuard Connect</Typography>

						<Divider
							sx={{
								borderWidth: "2px",
								borderColor: "var(--color-primary-main)",
								marginTop: "0.25rem",
								marginBottom: "0.5rem"
							}}
						/>

						<Typography variant="body2" sx={{ color: "text.secondary" }}>
							Cloud-based GateGuard solution for modern security management
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* GateGuard Connect On Premise Card */}
			<Box className="integration-card-wrapper" sx={{ minWidth: "300px", flex: "1 1 45%" }}>
				<Box className="integration-card" onClick={handleSelectGateGuardOnPremiseIntegration}>
					<Box className="integration-card-image-wrapper">
						<GateGuardOnPremiseLogo className="onprem" />
					</Box>

					<Box className="integration-card-content-wrapper">
						<Typography variant="h6">GateGuard Connect On Premise</Typography>

						<Divider
							sx={{
								borderWidth: "2px",
								borderColor: "var(--color-primary-main)",
								marginTop: "0.25rem",
								marginBottom: "0.5rem"
							}}
						/>

						<Typography variant="body2" sx={{ color: "text.secondary" }}>
							On-premise GateGuard deployment for enhanced security and control
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* GateGuard Offline Card */}
			<Box className="integration-card-wrapper" sx={{ minWidth: "300px", flex: "1 1 45%" }}>
				<Box className="integration-card" onClick={handleSelectGateGuardOfflineIntegration}>
					<Box className="integration-card-image-wrapper">
						<GateGuardOfflineLogo className="offline" />
					</Box>

					<Box className="integration-card-content-wrapper">
						<Typography variant="h6">GateGuard Offline</Typography>

						<Divider
							sx={{
								borderWidth: "2px",
								borderColor: "var(--color-primary-main)",
								marginTop: "0.25rem",
								marginBottom: "0.5rem"
							}}
						/>

						<Typography variant="body2" sx={{ color: "text.secondary" }}>
							Standalone GateGuard solution for environments without internet connectivity
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default IntegrationSelection;
